import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'header',
    label: 'Header',
    type: types.OBJECT,
    children: [
      {
        key: 'tagline',
        label: 'Tagline',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'scroll_in_animation',
    label: 'Scroll-In Animation',
    type: types.BOOLEAN
  },
  {
    key: 'main_featured',
    label: 'Main Featured Post',
    type: types.FUTURESIGHT_CONNECT,
    children: [
      {
        key: 'heroImageUrl',
        label: 'Hero Image',
        type: types.TEXT
      },
      {
        key: 'published_at',
        label: 'Published At',
        type: types.DATE
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXTAREA
      },
      {
        key: 'tags',
        label: 'Tags',
        type: types.ARRAY,
        children: {
          key: 'tag',
          label: 'Tag',
          type: types.TEXT
        }
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'featured',
        label: 'Featured',
        type: types.BOOLEAN
      }
    ]
  },
  {
    key: 'list',
    label: 'Featured Posts List',
    type: types.FUTURESIGHT_CONNECT,
    children: [
      {
        key: 'heroImageUrl',
        label: 'Hero Image',
        type: types.TEXT
      },
      {
        key: 'published_at',
        label: 'Published At',
        type: types.DATE
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXTAREA
      },
      {
        key: 'tags',
        label: 'Tags',
        type: types.ARRAY,
        children: {
          key: 'tag',
          label: 'Tag',
          type: types.TEXT
        }
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'featured',
        label: 'Featured',
        type: types.BOOLEAN
      }
    ]
  },
  {
    key: 'more_link',
    label: 'FutureSight Link',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT_WITH_ICON,
        children: [
          { key: 'text', label: 'Text' },
          { key: 'icon', label: 'Icon' },
          { key: 'placement', label: 'Placement' }
        ]
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  header: {
    tagline: 'The official ff blog',
    title: 'FUTURESIGHT'
  },
  scroll_in_animation: true,
  main_featured: [],
  list: [],
  more_link: {
    label: {
      text: 'More from futuresight',
      icon: 'ff-icon-long-arrow-right',
      placement: 'AFTER'
    },
    url: '/us/futuresight/'
  }
};

export default {
  title: 'FutureSight Features',
  id: 'FutureSightFeatures',
  propsSchema,
  defaultProps
};
